import { render, staticRenderFns } from "./PermissionEdit.vue?vue&type=template&id=8fd5095a&scoped=true"
import script from "./PermissionEdit.vue?vue&type=script&lang=js"
export * from "./PermissionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd5095a",
  null
  
)

export default component.exports